export class ValidationUtil {
  
  static ValidateEmail(email: string) {
    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
    return pattern.test(email);
  }

  static ValidateForSpecialCharacters(text: string) {
    const pattern = /[^\w\d ]/g;
    return pattern.test(text);
  }
}
